module.exports = __webpack_public_path__ + "img/music_010.e41841fe.png";